export const testIds = {
  navTopLevel: 'sdsm-global-nav-screen',
  closeButton: 'sdsm-global-nav-screen-close',
  navItems: 'sdsm-global-nav-screen-items',
  navHighlights: 'sdsm-global-nav-screen-highlights',
};
